import { selectOrderForBooking, setBookingThreadMod } from 'entities/orders';
import {
	BookingTime,
	selectSelectedTimeslot,
} from 'entities/toolbar/timeslots';
import { useClientForm } from 'features/booking/BookingClientForm';
import { FC, useEffect, useMemo, useState } from 'react';
import { FULL_SLOT } from 'shared/consts';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { TColorText } from 'shared/types';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

interface SlotProps {
	currentSlot: string;
	disabledSlot: BookingTime | null;
	bookingTime: BookingTime;
	activeSlot: (bookingTime: BookingTime) => void;
	changeSlotsLabelText: (text: string) => void;
}

export const BookingSlot: FC<SlotProps> = ({
	currentSlot,
	disabledSlot,
	bookingTime,
	activeSlot,
	changeSlotsLabelText,
}) => {
	const [colorText, setColorText] = useState<TColorText>('basic');
	const [borderColor, setBorderColor] = useState('');
	const { activeBookingBtn } = useClientForm();
	const order = useAppSelector(selectOrderForBooking);
	const selectedTimeslot = useAppSelector(selectSelectedTimeslot);
	const dispatch = useAppDispatch();

	const clickBySlotHandler = () => {
		if (order?.status !== 'visit_started') {
			activeSlot(bookingTime);
			activeBookingBtn();
			if (bookingTime.date !== selectedTimeslot) {
				dispatch(setBookingThreadMod({ isWork: false }));
			}
		}
	};

	const background = useMemo(() => {
		if (currentSlot !== bookingTime.time) {
			return 'white';
		}

		if (bookingTime.time === disabledSlot?.time) {
			return 'white';
		}
	}, [bookingTime, currentSlot, disabledSlot]);

	useEffect(() => {
		if (bookingTime.time === disabledSlot?.time) {
			setColorText('danger');
			setBorderColor(FULL_SLOT);
			changeSlotsLabelText('Выберите доступный слот');
		} else if (currentSlot !== bookingTime.time) {
			setColorText('basic');
			setBorderColor('');
		} else {
			setColorText('default');
		}
	}, [bookingTime, disabledSlot, currentSlot, changeSlotsLabelText]);

	return (
		<ButtonContained
			padding="8px 12px"
			background={background}
			color={colorText}
			borderColor={borderColor}
			onClick={clickBySlotHandler}
			hover={false}
		>
			{bookingTime.time}
		</ButtonContained>
	);
};
